<template>
  <p>
    Entre em contato com a empresa parceira para ter acesso ao boleto de pagamento desta parcela.
  </p>
</template>
